<template>
    <div>
      <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
      <h4 class="text-center"><strong>Review</strong></h4>
      <campaign-form :campaign="campaign" />
      <b-form-group
        label="Listings"
        :label-cols="3"
        :horizontal="true"
      >
        <ul class="list-unstyled">
          <li v-for="listing in campaign.listings" :key="'camp-tab-list-'+listing.id">
            {{listing.name}}
          </li>
        </ul>
      </b-form-group>
      <schedule-campaign @click="onScheduled"/>
    </div>
</template>

<script>
    import ScheduleCampaign from "./ScheduleCampaign";
    import {handleErrors} from "../../../../shared/utils";
    import {RepositoryFactory} from "../../../../services/repositories/RepositoryFactory";
    import router from "@/router";
    import CampaignForm from "../CampaignForm";
    import VueLoading from "vue-loading-overlay/src/js/Component";

    export default {
      name: "ScheduleSendTab",
      components: {
        CampaignForm,
        ScheduleCampaign,
        VueLoading
      },
      props: {
        campaign: {
          type: Object,
          default: new Object(),
        },
      },
      data() {
        return {
          isLoading: false,
        }
      },
      methods: {
        onScheduled(date) {
          this.isLoading = true;
          this.campaign.sendAt = this.$moment(date).format();
          RepositoryFactory
            .get('newsletterCampaign')
            .createCampaign(this.campaign)
            .then(
              response => {
                this.isLoading = false;
                router.push({name: 'campaign-item', params: {campaignId: response.data.data.id}})
              }
            ).catch(
            response => (
              handleErrors(response).forEach(
                value => {
                  this.flash(value,'error')
                  this.isLoading = false;
                }
              )
            )
          )
        },
      }
    }
</script>

<style scoped>

</style>
